// extracted by mini-css-extract-plugin
export default {"units":"units__vr0Fs"};